// extracted by mini-css-extract-plugin
export default {"textInputWithPageSelection":"TextInputWithPageSelection_textInputWithPageSelection__FqmhM","openText":"TextInputWithPageSelection_openText__x-X4m"};